import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

import { TodayCountsService } from '../../../services/today-counts.service';
import { QuickStatsFilterService } from '../../../services/quick-stats-filter.service';
import { NotificationCountService } from '../../../services/notification-count.service';
import { ActiveDriversComponent } from '@app/components/admin/active-drivers/active-drivers.component';
import { MatDialog } from '@angular/material/dialog';
import { PlanService } from '@app/services/plan.service';
import { ToastService } from '@app/services/toast.service';
import { AuthServiceService } from '@app/services/auth-service.service';
import { OrderService } from '@app/services/order.service';
import { TicketsService } from '@app/services/tickets.service';
import { ChatbotService } from '@app/services/chatbot.service';
import { Subscription, Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { WebsocketnotificationService } from '@app/services/websocketnotification.service';
import { DialogService } from '@app/services/dialog.service';
import { ReceivingAdminService } from '../../../services/receiving-admin.service';
import { ShareddtaService } from '@app/services/shareddta.service';
interface Message {
  text: string;
  sender: 'user' | 'bot';
  time: string;
}
export interface Notification {
  id: number;
  title: string;
  message: string;
  orderNumber?: string;
  time: string;
  dateGroup: 'Today' | 'Yesterday' | 'This Week' | 'Older';
  isUnread: boolean;
  iconType: 'success' | 'delivery' | 'time' | 'message';
}
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {

  @Output() menuToggle = new EventEmitter<void>();

  // State
  isProduction = environment.production;
  dashboardTitle = 'Shipping Dashboard';

  isReceivingAdminPage = false;
  currentDate = '';
  searchQuery = '';
  showFlotingtoggel: boolean = false;
  // Quick stats
  quickStats = {
    todayOrders: 0,
    deliveries: 0,
    pickup: 0,
    active_driver_count: 0
  };

  // Active tab for quick stats
  activeTab: string | null = '';
  tabName: string | null = '';
  // Drivers active
  driversActive = 6;
  // Notifications
  notificationCount = 0;
  _isRoleName: any = '0';
  isAnimating: boolean = true;
  placeholders: string[] = [
    'Search by Order Number',
    'Search by Purchase Order',
    'Search by Company Name',
    'Search by Company Address'
  ];

  currentPlaceholder: string = this.placeholders[0];
  placeholderIndex: number = 0;
  private searchSubject = new Subject<string>();
  constructor(
    private router: Router,
    private todayCountsService: TodayCountsService,
    private quickStatsFilterService: QuickStatsFilterService, public websocketnotification: WebsocketnotificationService,
    private notificationCountService: NotificationCountService, private dialog: MatDialog, public planService: PlanService, private toast: ToastService, private authService: AuthServiceService, private orderService: OrderService, private ticketService: TicketsService, private voiceRecognition: ChatbotService,
    private dialogService: DialogService,
    private receivingService: ReceivingAdminService,
    private sharedData: ShareddtaService
  ) { }
  @Input() isRoleIn: any;
  todayDelivery: number = 0;
  active_driver_count: number = 0;
  todayPickup: number = 0;
  todayTotalDP: number = 0;
  ngOnInit(): void {
    setTimeout(() => {
      this.websocketnotification.connectWebSocket();
    }, 3000);
    const savedTab = localStorage.getItem('orderHeaderActiveTab');
    this.searchQuery = localStorage.getItem('orderHeaderSearch') || '';
    this.shufflePlaceholders();
    this.startPlaceholderAnimation();
    if (savedTab) {
      this.setActiveTab(savedTab);
    }

    // 🔹 Push initial search text to service for immediate result loading
    if (this.searchQuery) {
      this.quickStatsFilterService.updateQuickStatsFilter(
        this.activeTab,
        this.todayDate,
        this.tabName === 'deliveries' ? 'delivery' : this.tabName,
        this.searchQuery
      );
    }
    // Subscribe to notification count
    this.notificationCountService.notificationCount$.subscribe(count => {
      this.notificationCount = count;
    });
    this.authService.getRole().subscribe((data: any) => {
      if (data != false) {
        this.isRoleIn = data[0];
      } else {
        this.isRoleIn = data;
      }
      this.notificationCountService.triggerRefresh();
    });
    this.websocketnotification.receiveData((data) => {
      if (data) {
        this.notificationCountService.triggerRefresh();
      }
    });
    this._isRoleName = this.authService._isRoleName;
    this.updateCurrentDate();
    // Update date every minute
    setInterval(() => {
      this.updateCurrentDate();
    }, 60000);
    // 🔥 Initial route check (page refresh case)
    this.setActiveFromRoute(this.router.url);

    // 🔥 Route change listen (navigation ke baad)
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setActiveFromRoute(event.urlAfterRedirects);
      }
    });

    // Subscribe to today's counts from service (Receiving Side)
    this.todayCountsService.todayCounts$.subscribe(counts => {
      if (this.isReceivingAdminPage) {
        console.log('Received today counts in header (Receiving Side):', counts);
        this.quickStats.deliveries = counts.delivery;
        this.quickStats.pickup = counts.pickup;
        this.quickStats.todayOrders = counts.total;
        this.quickStats.active_driver_count = counts.active_driver_count;

        // Sync template variables
        this.todayTotalDP = counts.total;
        this.todayDelivery = counts.delivery;
        this.todayPickup = counts.pickup;
        this.active_driver_count = counts.active_driver_count;
      }
    });

    this.quickStatsFilterService.quickStatsFilter$.subscribe(filter => {
      if (!filter.tab && !filter.searchtext) {
        this.activeTab = null;
        this.tabName = null;
        this.searchQuery = '';
        this.searchSubject.next('');
      }
    });
    this.initVoiceInput();
    this.voiceRecognition.isRecording$.subscribe((isRecording: boolean) => {
      this.isRecording = isRecording; // Update the component state
    });
    this.voiceRecognition.chatbotVisible$.subscribe((visible: boolean) => {
      this.isChatOpen = visible;
      if (visible) {
        this.activeActions = 'ai';
        setTimeout(() => this.scrollToBottom(), 100);
      } else {
        this.activeActions = '';
      }
    });
    this.orderService.getOrderCount().subscribe(data => {
      // Guard: Only update if we are NOT on the receiving admin page
      if (data && data.result && data.result.all && this.isRoleIn != '3' && !this.isReceivingAdminPage) {
        const todayList = data.result.today;
        this.todayDelivery = this.getTypeCount(todayList, 'delivery');
        this.todayPickup = this.getTypeCount(todayList, 'pickup');
        this.todayTotalDP = this.todayDelivery + this.todayPickup;
        this.active_driver_count = data.result.active_driver_count || 0;
      }
    });
    // this.fetchOrderCounts(); // Removed to avoid duplicate hitting of API

    // 🔹 Setup Debounced Search
    this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(query => {
      this.triggerFilterUpdate(query);
    });
  }
  getTypeCount(list: any, type: string): number {
    if (!list) return 0;
    if (Array.isArray(list)) {
      const found = list.find(item => (item.order_type || item.type || '').toLowerCase() === type.toLowerCase());
      return found ? (Number(found.count) || 0) : 0;
    }
    return 0;
  }
  initVoiceInput() {
    // Subscription for initializing voice input
    this.voiceRecognition.init().subscribe(() => {
      // Voice recognition initialization complete, handle any necessary setup here
    });

    // Subscription to detect user input from voice to text.
    // this.voiceRecognition.speechInput().subscribe((input: string) => {
    //   // Set the voice recognition text output to userMessage
    //   this.userInput = input;
    // });
  }
  todaysDate: any;
  private fetchOrderCounts(): void {
    const currentUrl = this.router.url;
    // Guard: Only fetch if authenticated
    if (!this.authService.getToken) {
      console.log('Skipping header fetchOrderCounts (No auth token)');
      return;
    }
    if (currentUrl.includes('/admin/orders') || 
        currentUrl.includes('/admin/dashboard') || 
        currentUrl.includes('/admin/driver/detail/') ||
        currentUrl.includes('/receiving-admin/orders')) {
      console.log('Skipping header fetchOrderCounts (Handled by page component)');
      return;
    }

    const roleId = this.isRoleIn;
    let date = new Date();
    let formatDate =
      date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
    this.todaysDate = formatDate;

    if (roleId == '3' || this.isReceivingAdminPage) {
      this.receivingService.getReceivingOrderCounts(undefined, undefined, this.todaysDate).subscribe(response => {
        const data = response?.result || response;
        if (data) {
          const todayStats = data.today || data;
          const delivery = this.getTypeCount(todayStats, 'delivery');
          const pickup = this.getTypeCount(todayStats, 'pickup');
          const activeDrivers = data.active_driver_count || 0;
          this.todayCountsService.updateTodayCounts(delivery, pickup, activeDrivers);
        }
      });
    } else {
      this.orderService.orderCount(
        null,
        null,
        null,
        null,
        this.todaysDate,  // today_date
        null,  // ispending
      );
    }
  }

  /**
   * @description Function to enable voice input.
   */
  startListening() {
    if (this.isRecording) {
      // Stop the recording
      this.voiceRecognition.stopRecording();
    } else {
      // Start the recording
      this.startRecording();
    }
  }

  /**
   * @description Function to start recording
   */
  voiceSub!: Subscription;
  startRecording() {
    this.isRecording = true;
    this.voiceRecognition.start(); // Start voice recognition
    this.userInput = ''; // Reset the input field for new input
    this.voiceSub = this.voiceRecognition
      .speechInput()
      .subscribe((input: string) => {
        this.userInput = input;
      });
  }

  /**
   * @description Function to stop recording
   */
  stopRecording() {
    this.isRecording = false;
    if (this.voiceSub) {
      this.voiceRecognition.stop(); // Stop voice recognition
      this.voiceSub.unsubscribe();
    }
  }
  shufflePlaceholders() {
    for (let i = this.placeholders.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.placeholders[i], this.placeholders[j]] = [this.placeholders[j], this.placeholders[i]];
    }
    this.currentPlaceholder = this.placeholders[0];
  }

  startPlaceholderAnimation() {
    setInterval(() => {
      this.isAnimating = false; // Reset to trigger re-animation if we used a flag
      setTimeout(() => {
        this.placeholderIndex = (this.placeholderIndex + 1) % this.placeholders.length;
        this.currentPlaceholder = this.placeholders[this.placeholderIndex];
        this.isAnimating = true;
      }, 50); // Small gap
    }, 4000); // 4 seconds discrete cycle
  }

  setActiveFromRoute(url: string) {
    const wasReceivingBefore = this.isReceivingAdminPage;
    this.isReceivingAdminPage = url.includes('/receiving-admin');

    // Clear active tab if the dashboard context changed (Shipping <-> Receiving)
    if (wasReceivingBefore !== this.isReceivingAdminPage) {
      this.activeTab = null;
      this.tabName = null;
      localStorage.removeItem('orderHeaderActiveTab');
      this.quickStatsFilterService.updateQuickStatsFilter(null, null, null, this.searchQuery);
      console.log('Dashboard context switch: filters cleared');
    }

    if (this.isReceivingAdminPage) {
      this.dashboardTitle = 'Receiving Dashboard';
    } else {
      this.dashboardTitle = 'Shipping Dashboard';
    }

    // Refresh counts when switching dashboard context
    this.fetchOrderCounts();

    const routeMap: any = {
      'orders/add': 'add',
      'orders/edit': 'edit',
      locate: 'locate',
      notifications: 'notify',
      beta: 'beta'
    };

    for (const key in routeMap) {
      if (url.includes(key)) {
        this.activeAction = routeMap[key];
        return;
      }
    }

    this.activeAction = null;
  }

  updateCurrentDate(): void {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    this.currentDate = now.toLocaleDateString('en-US', options);
  }

  onMenuToggle(): void {
    this.menuToggle.emit();
  }
  cross: boolean = false
  onSearch(): void {
    if (this.searchQuery && this.searchQuery.length > 0) {
      this.cross = true;
      // 🔹 Push to debounced subject
      this.searchSubject.next(this.searchQuery);
    } else {
      this.cross = false;
      // 🔹 Instant Reset if empty (User backspaced everything)
      this.triggerFilterUpdate('');
    }

    localStorage.setItem('orderHeaderSearch', this.searchQuery);

    // 🔹 Intelligent Redirection logic (Immediate navigate, debounced data)
    if (this.searchQuery && this.searchQuery.length > 0) {
      const currentRoute = this.router.url;
      const targetRoute = this.isReceivingAdminPage ? '/receiving-admin/orders' : '/admin/dashboard';
      
      const isArchiveRoute = currentRoute.includes('/admin/archive-order');
      const isDriverOrdersRoute = currentRoute.includes('/admin/driver/detail/');
      const isOrderDetail = currentRoute.includes('/order-detail');

      // 🔥 Redirect if on a detail page or not on a listing page
      if (isOrderDetail || (!currentRoute.includes(targetRoute) && !isArchiveRoute && !isDriverOrdersRoute)) {
        this.router.navigate([targetRoute]);
      }
    }
  }

  /**
   * 🔹 CENTRAL FILTER TRIGGER: Used for both debounced and instant updates
   */
  private triggerFilterUpdate(query: string): void {
    this.quickStatsFilterService.updateQuickStatsFilter(
      this.activeTab,
      this.activeTab ? this.todayDate : null,
      this.tabName === 'deliveries' ? 'delivery' : this.tabName,
      query
    );
  }

  onDriversClick(): void {
    console.log('Show drivers list');
    // Pre-emptively signal dialog opening to destroy charts/heavy UI before layout reflow
    this.sharedData.setDialogState(true);
    
    const dialogRef = this.dialog.open(ActiveDriversComponent, {
      width: '800px',
      maxHeight: '90vh',
      panelClass: 'drivers-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
      // Signal dialog closed to recreate any paused UI
      this.sharedData.setDialogState(false);
    });
  }

  onNotificationsClick(): void {
    console.log('Show notifications');
    this.isOpen = !this.isOpen;
     const roleData = this.authService.getLS('role');
          if(roleData){
            const roleId = roleData[0];
            this.isRoleIn = roleId;
          }
     if (this.isRoleIn == '2') {
          this.notificationListShipping(true);
        }
        if (this.isRoleIn == '3') {
         this.notificationListReciving(true);
        }
    // Implement notifications dropdown
  }
      notificationListReciving(isClearNotification: boolean) {

    this.planService.notificationListReciving().subscribe((res) => {
      if(res.resultCode == 0){
        return
      }
      this.notificationListData = res.result.results;
     let ids = this.notificationListData
  .filter((e: any) => e && e.is_read === false)
  .map((e: any) => e.id);

if (isClearNotification && ids.length > 0) {
  this.clearNotification(ids);
}
    })
  }
  betaFeedbackClick(): void {
    console.log('Show notifications');
    this.isOpen = !this.isOpen;
    // Implement notifications dropdown
  }

  onAddOrder = (): void => {
    console.log('Add new order');
    // Navigate to add order page
    this.router.navigate(['/admin/orders/add']);
  }

  onLocateDriver = (): void => {
    console.log('Locate driver');
    this.router.navigate(['/admin/locate-driver']);
    // Open map/driver location modal
  }

  onAskRTTAI = (): void => {
    console.log('Ask RTT AI');
    // Open AI assistant modal
  }

  onNotifications = (): void => {
    console.log('View notifications');
    // this.router.navigate(['/admin/send-notification'])
    // Open notifications panel
  }

  onBetaFeedback = (): void => {
    console.log('Beta feedback');
    this.router.navigate(['/admin/beta-feedback']);
    // Open feedback modal
  }

  onRefresh(): void {
    console.log('Refreshing dashboard...');
    localStorage.removeItem('ordersCache');
    localStorage.removeItem('arkiveOrdersCache');
    localStorage.removeItem('updatedOrder');
    localStorage.removeItem('cachedPage');
    localStorage.removeItem('orderListScroll');
    localStorage.removeItem('cachedTotalCount');
    localStorage.removeItem('fromOrderDetail');
    
    window.location.reload();
  }
  activeAction: string | null = null;
  activeActions: string | null = null;

  setActive(action: string, callback?: () => void) {
    this.activeAction = action;
    if (callback) callback();
  }
  todayDate: any;
  setActiveTab(tabName: string): void {
    // Toggle behavior: if clicking same tab, deactivate it
    localStorage.setItem('ordersCache', JSON.stringify([])); // Clear orders cache on tab change,
    if (this.activeTab === tabName) {
      this.activeTab = null;
      this.tabName = null;
      // Clear filters
      localStorage.removeItem('orderHeaderActiveTab'); // Remove from localStorage
      this.quickStatsFilterService.updateQuickStatsFilter(null, null, null, this.searchQuery);
      console.log('Tab deactivated:', tabName);
    } else {
      this.activeTab = tabName;
      this.tabName = tabName
      localStorage.setItem('orderHeaderActiveTab', tabName); // Save to localStorage
      // Get today's date in YYYY-MM-DD format
      const today = new Date();
      const todayDate = today.getFullYear() + '-' +
        String(today.getMonth() + 1).padStart(2, '0') + '-' +
        String(today.getDate()).padStart(2, '0');
      this.todayDate = todayDate
      // Set filter based on tab clicked
      if (tabName === 'todayOrders') {
        // Show all today's orders (both delivery and pickup)
        this.quickStatsFilterService.updateQuickStatsFilter(tabName, todayDate, null, this.searchQuery);
        console.log('Showing today orders with date:', todayDate);
      } else if (tabName === 'deliveries') {
        // Show only today's deliveries
        this.quickStatsFilterService.updateQuickStatsFilter(tabName, todayDate, 'delivery', this.searchQuery);
        console.log('Showing today deliveries with date:', todayDate);
      } else if (tabName === 'pickup') {
        // Show only today's pickups
        this.quickStatsFilterService.updateQuickStatsFilter(tabName, todayDate, 'pickup', this.searchQuery);
        console.log('Showing today pickups with date:', todayDate);
      }

      // If user is not on the orders list page, navigate back to it
      const currentRoute = this.router.url;
      const targetRoute = (this.isReceivingAdminPage || this.isRoleIn == '3') ? '/receiving-admin/orders' : '/admin/dashboard';

      if (!currentRoute.includes(targetRoute)) {
        this.router.navigate([targetRoute]);
      }
      // Removed fetchOrderCounts call to avoid duplicate hitting of API
    }
  }

  setActives(action: string, callback?: () => void) {
    this.activeActions = action;
    if (callback) callback();
  }
  clearText() {
    this.searchQuery = '';
    localStorage.removeItem('orderHeaderSearch'); 
    localStorage.setItem('isSearchApplied', 'true');
    this.cross = false;
    
    // 🔹 Clear subject buffer
    this.searchSubject.next('');
    
    // 🔹 INSTANT RESET (Skip debounce for better feel)
    this.triggerFilterUpdate('');
  }
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;

  isChatOpen = false;
  isRecording = false;
  userInput = '';
  showWelcome = true;
  isTyping = false;
  messages: Message[] = [];

  toggleChatbot() {
    this.voiceRecognition.toggleChatbotVisibility();
  }
  closetoggleChatbot() {
    this.showFlotingtoggel = false;
    this.voiceRecognition.setChatbotVisibility(false);
    this.activeActions = '';
  }
  mintoggleChatbot() {
    this.showFlotingtoggel = true;
    this.voiceRecognition.setChatbotVisibility(false);
  }

  // sendMessage() {
  //   this.isRecording = false;
  //   this.voiceRecognition.stopRecording(); 
  //   const text = this.userInput.trim();
  //   if (!text) return;

  //   if (this.showWelcome) this.showWelcome = false;
  //   // User Message
  //   this.addMessage(text, 'user');
  //   this.userInput = '';

  //   // Bot Response simulation
  //   this.isTyping = true;
  //   this.scrollToBottom();

  //   setTimeout(() => {
  //      this.userInput = '';
  //     this.isTyping = false;
  //     this.generateBotResponse(text);
  //   }, 1500);
  // }
  sendMessage() {
    const text = this.userInput.trim();
    if (this.voiceSub) {
      this.voiceSub.unsubscribe();
      setTimeout(() => {
        this.userInput = '';
      }, 2000);
    }
    // 🎤 Mic stop karo agar chal raha ho
    this.isRecording = false;
    this.voiceRecognition.stopRecording();

    if (!text) return;

    if (this.showWelcome) this.showWelcome = false;
    this.isTyping = true;
    // ✅ 1. User message add
    this.addMessage(text, 'user');

    // Clear input
    this.userInput = '';

    this.scrollToBottom();

    // ✅ 3. API call
    this.orderService.sendMessage(text).subscribe({

      next: (response: any) => {


        // 🔥 Yahan apna actual response key use karo
        const botReply =
          response?.result || 'No response from server';
        this.isTyping = false;
        this.addMessage(botReply, 'bot');
        if (this.voiceSub) {
          this.voiceSub.unsubscribe();
          this.userInput = '';
        }
        this.scrollToBottom();
      },

      error: (error: any) => {


        this.addMessage(
          'Sorry, something went wrong. Please try again later.',
          'bot'
        );

        this.scrollToBottom();

        console.error('Chat API Error:', error);
      }

    });
  }

  // addMessage(text: string, sender: 'user' | 'bot') {
  //   const time = new Date().toLocaleTimeString('en-US', {
  //     hour: 'numeric',
  //     minute: '2-digit',
  //     hour12: true
  //   });
  //   this.messages.push({ text, sender, time });
  //   setTimeout(() => this.scrollToBottom(), 10);
  // }
  addMessage(text: string, sender: 'user' | 'bot') {

    let formattedText = text;

    // ✅ Sirf bot message ko format karo
    if (sender === 'bot') {

      // Double newline
      formattedText = formattedText[0]
        .replace(/\n\n/g, '<br><br>')
        .replace(/\n/g, '<br>');

      // Bold formatting (**text**)
      formattedText = formattedText
        .replace(/\*\*(.*?)\*\*/g, '<span class="custom-bold">$1</span>');
    }

    const time = new Date().toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });

    this.messages.push({
      text: formattedText,
      sender,
      time
    });

    setTimeout(() => this.scrollToBottom(), 10);
  }


  generateBotResponse(userMsg: string) {
    let response = "";
    const msg = userMsg.toLowerCase();

    if (msg.includes('order')) {
      response = "I can help you track your order! Order #6252661 is currently out for delivery and should arrive by 12:00 PM today.";
    } else if (msg.includes('driver')) {
      response = "Currently, you have 5 drivers available: Sandeep S, Rajesh K, Amit P, Priya M, and Rahul T.";
    } else if (msg.includes('deliver')) {
      response = "You have 12 deliveries scheduled for today. 8 are in progress, 3 are completed.";
    } else {
      response = "I'm here to help! I can assist you with Order tracking, Driver assignments, and Delivery schedules.";
    }

    this.addMessage(response, 'bot');
  }

  askQuestion(q: string) {
    this.userInput = q;
    this.sendMessage();
  }

  toggleVoice() {
    this.isRecording = !this.isRecording;
    if (this.isRecording) {
      this.startRecording();
    }
    else {
      setTimeout(() => {
        this.isRecording = false;
        this.voiceRecognition.stopRecording();
        if (this.voiceSub) {
          this.voiceSub.unsubscribe();
        }
        // this.userInput = 'Voice message transcribed';
      }, 3000);
    }
  }

  private scrollToBottom(): void {
    try {
      this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }

  isOpen = false;

  notifications: Notification[] = [
    { id: 1, title: 'Order Notification', message: 'has been unsuccessful', orderNumber: '6240344', time: '9 hours ago', dateGroup: 'Today', isUnread: true, iconType: 'success' },
    { id: 2, title: 'Order Notification', message: 'has been unsuccessful', orderNumber: '6239421', time: '1 day ago', dateGroup: 'Yesterday', isUnread: true, iconType: 'delivery' },
    { id: 3, title: 'Order Notification', message: 'has been unsuccessful', orderNumber: '6239422', time: '4 day ago', dateGroup: 'Yesterday', isUnread: true, iconType: 'time' },
    // Aur data yahan add kar sakte hain...
  ];

  get unreadCount() {
    return this.notifications.filter(n => n.isUnread).length;
  }

  get groupedNotifications() {
    const groups = ['Today', 'Yesterday', 'This Week', 'Older'];
    return groups.map(group => ({
      label: group,
      items: this.notifications.filter(n => n.dateGroup === group)
    })).filter(group => group.items.length > 0);
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  markAsRead(notification: Notification) {
    notification.isUnread = false;
  }

  deleteNotification(id: number, event: Event) {
    event.stopPropagation();
    this.notifications = this.notifications.filter(n => n.id !== id);
  }

  clearAll() {
    if (confirm('Are you sure?')) {
      this.notifications = [];
    }
  }

  viewOrder(orderNum: string) {
    console.log('Navigating to order:', orderNum);
    this.isOpen = false;
  }
  showDriverModal: boolean = false;

  openDriverModal() {
    this.showDriverModal = true;
  }

  closeDriverModal() {
    this.showDriverModal = false;
  }
  notificationListData: any;
  notificationListShipping(isClearNotification: boolean) {

    this.planService.notificationListShipping().subscribe((res) => {

      this.notificationListData = res.result.results;
      // let ids = this.notificationListData.filter(function (e: any) { return e }).map(function (e: any) {
      //   return e.id
      // });
      // if (isClearNotification) {
      //   this.clearNotification(ids)
      // }
      let ids = this.notificationListData
  .filter((e: any) => e && e.is_read === false)
  .map((e: any) => e.id);

if (isClearNotification && ids.length > 0) {
  this.clearNotification(ids);
}
    })
  }

  clearNotification(id: any) {
    var formdata = new FormData();
    formdata.append('notif_ids', JSON.stringify(id));
    this.planService.clearNotification(formdata).subscribe((res: any) => {
      this.notificationCount = 0;
    })
  }
  isClearAllDeleteLoading: boolean = false;
  async clearAllNotifications() {
    const confirmed = await this.dialogService.confirm(
      'Clear Notifications',
      'Are you sure you want to clear all notifications? This action cannot be undone.',
      'Clear All',
      'Cancel'
    );

    if (confirmed.confirmed) {
      let ids = this.notificationListData.filter(function (e: any) { return e }).map(function (e: any) {
        return e.id
      });
      var formdata = new FormData();
      formdata.append('notif_ids', JSON.stringify(ids));
      this.isClearAllDeleteLoading = true;
      this.planService.deletNotification(formdata).subscribe((res) => {
        this.isClearAllDeleteLoading = false;
        this.notificationListData = res.result.results;

         if (this.isRoleIn == '2') {
          this.notificationListShipping(false);
        }
        if (this.isRoleIn == '3') {
         this.notificationListReciving(false);
        }
      }, (err: any) => {
        this.isClearAllDeleteLoading = false;
      })
    }
  }
  isDeleteId: any;
  isDeleteLoading: boolean = false;
  deleteNotifications(id: any) {
    var formdata = new FormData();
    formdata.append('notif_ids', JSON.stringify([Number(id)]));
    this.isDeleteLoading = true;
    this.isDeleteId = id;
    this.planService.deletNotification(formdata).subscribe((res) => {
      this.isDeleteLoading = false;
      if (res.resultDescription) {
        this.toast.show('success', res.resultDescription)
      }
       if (this.isRoleIn == '2') {
          this.notificationListShipping(true);
        }
        if (this.isRoleIn == '3') {
         this.notificationListReciving(true);
        }
    }, (err: any) => {
      this.isDeleteLoading = false;
    })
  }
  isTicketRoute: boolean = false;
  navigateToDetails(notification: any) {
    if (notification.notif_type === 'Ticket Notification') {
      // this.showNotificationsss();
      const currentRoute = this.router.url;
      this.isTicketRoute = currentRoute.includes('tickets');

      this.navigateToTicketDetails(notification.notif_detail_id, notification.sent_from_schema, notification.notif_type, notification.extra_data);
    } else if (notification.notif_type === 'Order Notification') {
      this.getOrderDetails(notification.notif_detail_id, notification.sent_from_schema);
    }
  }
  navigateToOrderDetails(id: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.navigate(['admin/orders/detail', Number(id)]);
  }
  navigateToTicketDetails(id: any, sent_from_schema: any, notif_type: any, extra_data?: any) {
    if (notif_type == 'Ticket Notification') {
      this.getTicketDetails(id, sent_from_schema, extra_data);
    }
    if (notif_type == 'Company Notification') {
      //  this.companyDetails(id,sent_from_schema);

    }
    // if(notif_type=='Order Notification'){
    //   this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    //   this.isShowNotificationss = !this.isShowNotificationss
    //   this.router.navigate(['admin/orders/detail', Number(id)]);

    // }
  }
  showNotificationsss() {
    this.notificationList(true);
  }
  notificationList(isClearNotification: boolean) {

    this.planService.notificationList().subscribe((res) => {

      this.notificationListData = res.result.results;
      let ids = this.notificationListData.filter(function (e: any) { return e }).map(function (e: any) {
        return e.id
      });
      if (isClearNotification) {
        this.clearNotification(ids)
      }
    })
  }
  orderDetailsss: any;
  getOrderDetails(id: any, sent_from_schema: any) {
      this._isRoleName = this.authService._isRoleName;
    if (this._isRoleName == "receiving-admin") {
      this.orderService.recivingOrderDetail(id,sent_from_schema).subscribe(
          (data:any) => {
            this.orderDetailsss = data?.result;
            if(this.orderDetailsss){
              this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.navigate(['/receiving-admin/orders/order-detail/',id], {
            queryParams: { schema:sent_from_schema }
        });
        this.isOpen = false;
            }
            else{
               this.toast.show('error',"Record not found")
              return
            }
          }, 
          () => {
             this.toast.show('error',"Unable to create ticket")
          }
        );
    }

    else {
      this.orderService.orderDetail(id).subscribe(
        (data: any) => {
          this.orderDetailsss = data?.result;
          if (this.orderDetailsss) {
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.navigate(['admin/orders/order-detail', Number(id)]);
            this.isOpen = false;
          }
          else {
            //  this.toast.show('error',"Record not found")
            return
          }
        },
        () => {
          this.toast.show('error', "Unable to create ticket");
        }
      );
    }
  }
  ticketDetails: any;
  getTicketDetails(id: any, sent_from_schema: any, extra_data: any) {
    if (extra_data && extra_data.type == 'nongeneral') {
      localStorage.setItem('notifictionextradata', extra_data.type)
      this.ticketService.getrecivingTicketDetails1(id, sent_from_schema).subscribe(
        (data: any) => {
          this.ticketDetails = data?.results;
          if (this.ticketDetails) {
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.isOpen = false;
            this.router.navigate([`${this.authService._isRoleName}/ticket/detail`, Number(id)]);
            // this.router.navigate(['admin/tickets', Number(id)+' '+sent_from_schema]);
          }
          else {
            // this.toastr.error("Record not found");
            return
          }
        },
        () => {
          this.toast.show('error', "Unable to create ticket");;
        }
      );
    }
    else {
      this.ticketService.getTicketDetails1(id, sent_from_schema).subscribe(
        (data: any) => {
          this.ticketDetails = data?.results;
          if (this.ticketDetails) {
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.navigate([`${this.authService._isRoleName}/ticket/detail`, Number(id)]);
            this.isOpen = false;
            //this.router.navigate(['admin/tickets', Number(id)+' '+sent_from_schema]);
          }
          else {
             this.toast.show('error', "Record not found");;
            //  this.toastr.error("Record not found");
            return
          }
        },
        () => {
          this.toast.show('error', "Unable to create ticket");
        }
      );
    }
  }
  notificationCountData: any;

  notificationCounts() { }

  notificationShipping() { }

  notificationReciver() { }
}
